import React from 'react';

import HooksProvider from 'bz-stores/hook/mobx-inject/provider';
import PaywallDialogStore from '../dialog/stores/paywall-dialog-store';

export interface IProps {}

const PaywallProvider: React.FC<IProps> = React.memo(({ children }) => {
  const { current: paywallDialogStore } = React.useRef<PaywallDialogStore>(
    new PaywallDialogStore()
  );

  return (
    <HooksProvider paywallDialogStore={paywallDialogStore}>
      <>{children}</>
    </HooksProvider>
  );
});

PaywallProvider.displayName = 'PaywallProvider';

export default PaywallProvider;
